import React from 'react';
import './Pagination.css';

const Pagination = ({
    totalItems,
    itemsPerPage,
    currentPage,
    onPageChange,
    onItemsPerPageChange,
    loading = false
}) => {

    // Calcula o total de páginas
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    // Se não houver itens, ou loading, pode optar por não mostrar ou mostrar desabilitado
    if (totalItems === 0 && !loading) return null;

    // Handler para mudança do select
    const handleLimitChange = (e) => {
        const newLimit = parseInt(e.target.value, 10);
        onItemsPerPageChange(newLimit);
    };

    return (
        <div className="pagination-floating-container">
            <div className="pagination-info">
                <span>
                    Total de Registros: <strong>{totalItems}</strong>
                </span>
                <div className="d-flex align-items-center gap-2">
                    <span>Exibir:</span>
                    <select
                        className="pagination-select-custom"
                        value={itemsPerPage}
                        onChange={handleLimitChange}
                        disabled={loading}
                    >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>
            </div>

            <div className="pagination-controls">
                <span className="page-info-text me-3">
                    Página {currentPage} de {totalPages || 1}
                </span>

                <button
                    className="page-btn"
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1 || loading}
                    title="Página Anterior"
                >
                    <i className="fas fa-chevron-left"></i>
                </button>

                <button
                    className="page-btn"
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages || totalPages === 0 || loading}
                    title="Próxima Página"
                >
                    <i className="fas fa-chevron-right"></i>
                </button>
            </div>
        </div>
    );
};

export default Pagination;
